import type { Role } from "@/modules/roles";
import { NO_PERMISSIONS_LABEL } from "../../roles.constants";
import styles from "./delete-role.module.scss";

export const ROLE_SUMMARY_TITLE = "INFORMAÇÕES DO PERFIL";

interface RoleSummaryProps {
  role: Role;
  testId: string;
}

/**
 * Bloco somente leitura com os dados do perfil selecionado (código, nome e
 * permissões em tags), compartilhado pelos dois pop-ups da exclusão.
 */
export function RoleSummary({ role, testId }: RoleSummaryProps) {
  return (
    <section className={styles.summary} data-testid={testId}>
      <h3 className={styles.summaryTitle}>{ROLE_SUMMARY_TITLE}</h3>

      <dl className={styles.summaryList}>
        <div className={styles.summaryRow}>
          <dt className={styles.summaryLabel}>Código:</dt>
          <dd className={styles.summaryValue}>{role.codigo}</dd>
        </div>

        <div className={styles.summaryRow}>
          <dt className={styles.summaryLabel}>Nome:</dt>
          <dd className={styles.summaryValue}>{role.nome}</dd>
        </div>

        <div className={styles.summaryRow}>
          <dt className={styles.summaryLabel}>Permissões:</dt>
          <dd className={styles.summaryValue}>
            <ul className={styles.tagList}>
              {role.permissoes.length === 0 ? (
                <li className={styles.tag}>{NO_PERMISSIONS_LABEL}</li>
              ) : (
                role.permissoes.map((permission) => (
                  <li key={permission.id} className={styles.tag}>
                    {permission.nome || permission.codigo}
                  </li>
                ))
              )}
            </ul>
          </dd>
        </div>
      </dl>
    </section>
  );
}
